import { useEffect } from "react";
import { Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ConfirmComponentContainer from "./ConfirmComponentContainer";
import FileStorage from "../../assets/img/file-storage.png";
import { useTranslation } from "react-i18next";
const ConfirmLoanIsSaved = (props) => {
    const { history, getApplicationById, applicationStringId } = props;
    const { applicationId } = props.match.params;
    const {t} = useTranslation();

    useEffect(() => {
        getApplicationById(applicationId)
    },[])

    const handleNext = () => {
        history.push('/dashboard');
    };
    const content = <Box mb="16px" mt="52px" color="#212121" fontSize="24px">
        <Box mb="16px">
            {t('APPLICATION_IS_SAVED')||"This loan application is saved."}
        </Box>
        <Box mb="16px">
            {t('APPLICATION_ID')||"The application ID is "}<b style={{ color: "#70b0ed" }}>#{applicationStringId}</b>.
        </Box>  
        <Box>
            {t('CUSTOMER_IS_SAVED')||"Customer can provide the details later for submission."}
        </Box>
    </Box >

    const buttons = <Button
        variant="contained"
        onClick={handleNext}
        type="submit"
        style={{ backgroundColor: "#5F56A6", font: "16px", padding: "10px 30px", textTransform: "none", color: "white" }}
    >
        {t('DONE')||"Done"}
    </Button>

    return (
        <ConfirmComponentContainer
            icon={FileStorage}
            content={content}
            buttons={buttons}
        />
    );
};

export default ConfirmLoanIsSaved;
